import { useAppSelector } from '@/hooks/useAppSelector';

import { selectSecurityAuditSecretsWithLeaksGroups } from '../services/selectors';

export const useSecurityAuditLeaksSecretsList = () => useAppSelector(selectSecurityAuditSecretsWithLeaksGroups);
